(() => {
  function createCustomerFormResponseCoordinator() {
    return {
      pending: false,
      focusedResponse: null,

      schedule() {
        if (this.pending) return;

        this.pending = true;
        const scheduleFrame = () => {
          window.requestAnimationFrame(() => {
            this.pending = false;
            this.scopeResponses();
          });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', scheduleFrame, { once: true });
        } else {
          scheduleFrame();
        }
      },

      scopeResponses() {
        const forms = Array.from(document.querySelectorAll('form.customer-response-form'));
        const targetId = window.location.hash.slice(1);
        const targetForm = forms.find((form) => {
          if (form.id === targetId) return true;

          const waitlist = form.closest('product-availability-waitlist');
          return waitlist?.id === targetId;
        });

        if (!targetForm) return;

        forms.forEach((form) => {
          const email = form.querySelector('[data-customer-form-email]');
          const responses = Array.from(form.querySelectorAll('[data-customer-form-response]'));

          responses.forEach((response) => {
            response.hidden = true;
          });
          email?.removeAttribute('aria-invalid');
          email?.removeAttribute('aria-describedby');

          if (form !== targetForm) return;

          const response =
            responses.find((item) => item.dataset.customerFormResponse === 'error') ||
            responses.find((item) => item.dataset.customerFormResponse === 'success');

          if (!response) return;

          response.hidden = false;
          email?.setAttribute('aria-describedby', response.id);
          if (response.dataset.customerFormResponse === 'error') {
            email?.setAttribute('aria-invalid', 'true');
          }

          if (this.focusedResponse !== response) {
            response.focus();
            this.focusedResponse = response;
          }
        });
      },
    };
  }

  let WaitlistElement = customElements.get('product-availability-waitlist');

  if (!WaitlistElement) {
    WaitlistElement = class ProductAvailabilityWaitlist extends HTMLElement {
      connectedCallback() {
        this.constructor.responseCoordinator.schedule();
      }
    };
    WaitlistElement.responseCoordinator = createCustomerFormResponseCoordinator();
    customElements.define('product-availability-waitlist', WaitlistElement);
  } else if (!WaitlistElement.responseCoordinator) {
    WaitlistElement.responseCoordinator = createCustomerFormResponseCoordinator();
  }

  WaitlistElement.responseCoordinator.schedule();
})();
